<template>
  <div class="flex justify-center dialog-content multiple">
    <div class="left-content content1 overflow-y no--sb" ref="content1">
      <div class="button-container" v-for="(data, idx) in leftData" :key="idx">
        <button class="flex align-center rounded pointer"
                :class="{active: selectedItem && selectedItem.val === data.val}"
                @click="storeItem(data)">
          <span v-if="data.hex"
                class="chip rounded"
                :style="{backgroundColor:data.hex}"></span>
          <span class="text">{{data.name}}</span>
          <!-- <span class="detail" @click="toggleSubDialog(data, true)">詳しく</span> -->
        </button>
      </div>
      <h5 class="content2-btn-title show">4月内石</h5>
      <div class="button-container show" v-for="(data, idx) in rightData" :key="idx">
        <button class="flex align-center rounded pointer"
                :class="{active: selectedItem && selectedItem.val === data.val}"
                @click="storeItem(data)">
          <span v-if="data.hex"
                class="chip rounded"
                :style="{backgroundColor:data.hex}"></span>
          <span class="text">{{data.name}}</span>
          <!-- <span class="detail" @click="toggleSubDialog(data, true)">詳しく</span> -->
        </button>
      </div>

      <!-- <button class="destiny pointer show">ディスティニーダイヤモンドとは</button> -->

      <div class="oval flex caution-container show">
        <i class="fas fa-info-circle"></i>
        <p>4.0mm幅以上をご希望の方は個別にお見積もりいたします。<br> シミュレーター上では3.8mmを選択の上、オーダー最後の自由欄にご希望のサイズをご入力ください。 K18グリーンゴールドは強度面からできましたら2.2幅以上をお選びください。</p>
      </div>

      <transition name="slideUp">
        <div class="flex align-center justify-center select-button show" v-if="selectedItem">
          <button class="oval transition pointer" @click="removeItem(selectedItem)">選択解除</button>
          <button class="oval transition pointer" @click="selectItem()">選択</button>
        </div>
      </transition>
    </div>

    <div class="flex-column align-end left-content content2 overflow-y no--sb relative">
      <div class="button-container" v-for="(data, idx) in rightData" :key="idx">
        <button class="flex align-center rounded pointer"
                :class="{active: selectedItem && selectedItem.val === data.val}"
                @click="storeItem(data)">
          <span v-if="data.hex"
                class="chip rounded"
                :style="{backgroundColor:data.hex}"></span>
          <span class="text">{{data.name}}</span>
          <span class="detail" @click="toggleSubDialog(data, true)" v-if="data.val === 'destinyDiamond'">詳しく</span>
        </button>
      </div>

      <!-- <button class="destiny pointer">ディスティニーダイヤモンドとは</button> -->

      <div class="oval flex caution-container">
        <i class="fas fa-info-circle"></i>
        <p>4.0mm幅以上をご希望の方は個別にお見積もりいたします。<br> シミュレーター上では3.8mmを選択の上、オーダー最後の自由欄にご希望のサイズをご入力ください。 K18グリーンゴールドは強度面からできましたら2.2幅以上をお選びください。</p>
      </div>

      <transition name="slideUp">
        <div class="flex align-center justify-center select-button" v-if="selectedItem">
          <button class="oval transition pointer" @click="removeItem(selectedItem)">選択解除</button>
          <button class="oval transition pointer" @click="selectItem()">選択</button>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import useDialogBuilder from "@/modules/moduleA/helpers/useDialogBuilder";
import {ref, watch} from "vue";

export default {
  name: "DiType5",
  props:{stepData:Array,},
  setup(props){
    const {currentRoute, toggleSubDialog, storeItem, selectItem, removeItem, selectedItem} = useDialogBuilder()

    const leftData = ref([])
    const rightData = ref([])
    const content1 = ref(null)

    props.stepData.forEach(item => {
      if (item.tab === 1){leftData.value.push(item)}
      else if (item.tab === 2){rightData.value.push(item)}
      else{}
    })

    watch(() => selectedItem.value, () => {
      scrollToBottom()
    })

    function scrollToBottom(){
      if (window.innerWidth <= 736){
        content1.value.scrollTop = content1.value.scrollHeight;
      }
    }

    return {currentRoute, toggleSubDialog, storeItem, selectItem, removeItem, selectedItem, leftData, rightData, content1}
  }
}
</script>

<style scoped>
.dialog-content {
  height: calc(100% - 30px);
}
.dialog-content > .content1 {
  width: calc(50% - 20px);
  padding-right: 20px;
}
.dialog-content > .content2 {
  padding-left: 20px;
  width: calc(50% - 20px);
}
.dialog-content > .content2 > button.destiny {
  margin-top: 14px;
  color: #797979;
  border-bottom: 1px solid #797979;
}
.dialog-content > .content2 > button.destiny:hover {
  margin-top: 14px;
  color: #1e272e;
  border-color: #22252f;
}
.dialog-content > .content2 > .caution-container {
  margin-top: 20px;
  background-color: #f5f6fa;
  padding: 10px;
}
.dialog-content > .content2 > .caution-container > p {
  margin-left: 10px;
  font-size: .8rem;
}
.dialog-content > .content2 > .select-button {
  margin-top: 40px;
  border-bottom-right-radius: 14px;
  border-bottom-left-radius: 14px;
  height: 70px;
  width: 100%;
}
.dialog-content > .content2 > .select-button > button {
  position: relative;
  z-index: 2;
  width: 100px;
  height: 40px;
  margin: 0 10px;
  padding-top: 2px;
  letter-spacing: 1.2px;
  background-color: rgba(245, 246, 250, .3);
  border: 2px solid rgba(220, 221, 225,1.0);
  color: #22252f;
}
.dialog-content > .content2 > .select-button > button:hover {
  transform: translateY(-3px);
  background-color: #171717;
  border-color: white;
  color: white;
}
</style>
